<template>
  <div class="articlemanagement">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="10"
            :lg="10"
          >
          <Divider orientation="left">{{ langMap.alarmHandlingRecord[lang] }}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.robot[lang]"
                class="leftFlex"
              >
                <Select v-model="robotId" :disabled="isHistoryMode">
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in robotList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.reportTime[lang]"
                class="leftFlex"
              >
                <Date-picker
                  v-model="times"
                  type="datetimerange"
                  :placeholder="langMap.selectDateAndTime[lang]"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                  :disabled="isHistoryMode"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="onSearchOrRecoverClick"
              >{{ searchButtonText }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading2"
        border
        :columns="col1"
        :data="dataList"
      ></Table>

      <div
        style="text-align:center;padding-top:10px;"
        v-if="dataList.length>0"
      >
        <Page
          :current="index"
          :total="dataTotal"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>

      <!-- 数据详情 -->
      <Modal
        :mask-closable="false"
        v-model="detailedDisplay"
        width="600px"
        :title="langMap.dataDetailInfo[lang]"
        class-name="sci-fi-modal detail-modal"
      >
        <Row>
          <Col span="24">
            <div class="sci-fi-detail-item">
              <div class="detail-label">{{ langMap.messageId[lang] }}</div>
              <div class="detail-value">{{showDetailData.messageId}}</div>
            </div>
          </Col>
          <Col span="24">
            <div class="sci-fi-detail-item">
              <div class="detail-label">{{ langMap.taskId[lang] }}</div>
              <div class="detail-value">{{showDetailData.taskId}}</div>
            </div>
          </Col>
          <Col span="24">
            <div class="sci-fi-detail-item">
              <div class="detail-label">{{ langMap.taskInfo[lang] }}</div>
              <div class="detail-value">{{langMap.targetDetected[lang]}}</div>
            </div>
          </Col>
          <Col span="24">
            <div class="sci-fi-detail-item image-container">
              <div class="detail-label">{{ langMap.imageDetail[lang] }}</div>
              <div class="detail-image-wrapper">
                <img :src="showDetailData.img" class="detail-image"/>
              </div>
            </div>
          </Col>
        </Row>
        <div slot="footer">
          <Button
            class="sci-fi-btn modal-close-btn"
            @click="cancelDetail"
          >{{ langMap.cancel[lang] }}</Button>
        </div>
      </Modal>

      <!-- 行为拒止弹窗组件 -->
      <BehaviorProhibitionModal
        :visible.sync="behaviorProhibitionModalVisible"
        :data="behaviorProhibitionData"
        :robot-code="currentBehaviorProhibitionRow ? currentBehaviorProhibitionRow.code : ''"
        :timestamp="currentBehaviorProhibitionRow ? currentBehaviorProhibitionRow.timestamp : ''"
        @success="onBehaviorProhibitionSuccess"
        @error="onBehaviorProhibitionError"
        @cancel="onBehaviorProhibitionCancel"
      />

      <!-- 音频播放弹窗组件 -->
      <AudioPlayerModal
        :visible="audioPlayerModalVisible"
        :robotInfo="audioPlayerRobotInfo"
        @close="closeAudioPlayerModal"
      />

      <!-- 语音对讲弹窗组件 -->
      <IntercomModal
        :visible="intercomModalVisible"
        :robotInfo="intercomRobotInfo"
        @close="closeIntercomModal"
      />

      <!-- 操作下发记录详情 -->
      <Modal
        :mask-closable="false"
        v-model="issuedDisplay"
        width="80%"
        :title="langMap.operationRecordDetail[lang]"
      >
        <!--<Row>
          <Row>
            <Col span="24">
            <div class="detail-item">
              <div>{{ langMap.publishTime[lang] }}：</div>
              <span>{{recordVO.publishTime}}</span>
            </div>
            </Col>
          </Row>
          <Col span="24">
          <div class="detail-item">
            <div>{{ langMap.publishType[lang] }}：</div>
            <span>{{recordVO.topic}}</span>
          </div>
          </Col>

          <Col span="24">
          <div class="detail-item">
            <div>{{ langMap.dataDetail[lang] }}：</div>
            <span>{{recordVO.data}}</span>
          </div>
          </Col>
        </Row>-->
        <Table
          :height="400"
          border
          :columns="col2"
          :data="recordList"
        ></Table>

        <div slot="footer">
          <Button
            class="sci-fi-btn modal-close-btn"
            @click="issuedDetail"
          >{{ langMap.cancel[lang] }}</Button>
        </div>
      </Modal>
    </Card>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import * as timeUtil from "@/utils/dateTimeUtil.js";
import Recorder from "js-audio-recorder";
import lamejs from "lamejs";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import BehaviorProhibitionModal from '@/components/BehaviorProhibitionModal';
import AudioPlayerModal from '@/components/AudioPlayerModal/index';
import IntercomModal from '@/components/IntercomModal/index';
export default {
  components: {
    BehaviorProhibitionModal,
    AudioPlayerModal,
    IntercomModal
  },
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      index: 1,
      dataList: [],
      dataTotal: 0,
      tableLoading2: false,
      times: [],
      isHistoryMode: false,
      dataType: "1",
      robotId: 0,
      title: "",
      robotList: [],

      //
      detailedDisplay: false,
      showDetailData: {},

      issuedDisplay: false,
      recordVO: {},
      recordList: [],
      getDisposalRecord: [],
      visible: false,

      // 行为拒止相关
      behaviorProhibitionModalVisible: false,
      behaviorProhibitionData: {},
      currentBehaviorProhibitionRow: null,

      // 音频播放弹窗相关
      audioPlayerModalVisible: false,
      audioPlayerRobotInfo: {},

      // 语音对讲弹窗相关
      intercomModalVisible: false,
      intercomRobotInfo: {},

      // 录音
      recorder: null,
      playTime: 0,
      timer: null,
      src: null,
      flag: true,
      icon: "ios-play-outline",

      buttonDisplay: true,
      //表格
      tableLoading: false,
      code: "",
      name: "",
      type: "",
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    searchButtonText() {
      if (this.isHistoryMode) {
        return this.lang === 'en' ? 'Restore search' : '恢复查询';
      }
      return this.langMap.search[this.lang];
    },
    col2() {
      return [
        {
          title: "#",
          width: 80,
          align:'center',
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.publishTime[this.lang],
          width: 150,
          key: "operateTime"
        },
        {
          title: langMap.publishType[this.lang],
          width: 130,
          key: "operateType",
          render: (h, { row }) => {
            let text = "";
            if (row.operateType == null) {
              text = "-";
            } else if (row.operateType == 1) {
              text = langMap.playWarning[this.lang];
            } else if (row.operateType == 2) {
              text = langMap.talkInspection[this.lang];
            } else if (row.operateType == 3) {
              text = langMap.trackAttack[this.lang];
            } else if (row.operateType == 4) {
              text = langMap.ignore[this.lang];
            } else if (row.operateType == 5) {
              text = langMap.disposalComplete[this.lang];
            } else if (row.operateType == 6){
              text = langMap.disposing[this.lang];
            } else if (row.operateType == 8){
              text = langMap.stopBehaviorProhibition[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.immediateResponse[this.lang],
          key: "rdata"
        },
        {
          title: langMap.asyncResponseCode[this.lang],
          key: "respCode"
        },
        {
          title: langMap.asyncResponseData[this.lang],
          key: "respData"
        },
        {
          title: langMap.asyncResponseMsg[this.lang],
          key: "respMsg"
        },
        {
          title: langMap.asyncResponseTime[this.lang],
          key: "respTime"
        },
      ]
    },
    col1() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          align: "center",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.robot[this.lang],
          width: 130,
          key: "code",
          align: "center"
        },
        {
          title: langMap.reportTime[this.lang],
          width: 180,
          key: "timestamp",
          align: "center",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },

        {
          title: langMap.dataInfo[this.lang],
          minWidth: 120,
          key: "data",
          align: "center",
          render: (h, params) => {
            let data = JSON.parse(params.row.data);
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  class: "sci-fi-btn detail-link-btn",
                  style: {
                    padding: "4px 4px"
                  },
                  on: {
                    click: () => {
                      this.detailedDisplay = true;
                      this.showDetailData = data;
                    }
                  }
                },
                langMap.dataDetailInfo[this.lang]
              )
            );
            return h("div", renderArray);
          }
        },
        {
          title: langMap.operationTime[this.lang],
          width: 180,
          key: "operateTime",
          align: "center",
        },
        {
          title: langMap.operationType[this.lang],
          width: 150,
          key: "operateType",
          align: "center",
          render: (h, { row }) => {
            let text = "";
            if (row.operateType == null) {
              text = "-";
            } else if (row.operateType == 1) {
              text = langMap.playWarning[this.lang];
            } else if (row.operateType == 2) {
              text = langMap.talkInspection[this.lang];
            } else if (row.operateType == 3) {
              text = langMap.trackAttack[this.lang];
            } else if (row.operateType == 4) {
              text = langMap.ignore[this.lang];
            } else if (row.operateType == 5) {
              text = langMap.disposalComplete[this.lang];
            } else if (row.operateType == 6){
              text = langMap.disposing[this.lang];
            } else if (row.operateType == 8){
              text = langMap.stopBehaviorProhibition[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.operationRecord[this.lang],
          width: 155,
          key: "recordVO",
          align: "center",
          render: (h, params) => {
            if (params.row.recordList !== null && params.row.recordList.length > 0) {
              let recordList = params.row.recordList;
              //渲染数组
              var renderArray = [];
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    class: "sci-fi-btn record-link-btn",
                    style: {
                      padding: "4px 4px"
                    },
                    on: {
                      click: () => {
                        this.issuedDisplay = true;
                        this.recordList = recordList;
                        // this.issuedData = data;
                      }
                    }
                  },
                  langMap.operationRecordDetail[this.lang]
                )
              );
              return h("div", renderArray);
            }
          }
        },
        {
          title: langMap.operation[this.lang],
          width: this.getOperationColumnWidth(),
          align: "center",
          render: (h, params) => {
            //渲染数组
            let renderArray = [];
            if(params.row.operateType === null){
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    class: "sci-fi-btn ignore-btn",
                    on: {
                      click: () => {
                        this.sentimentOperate(4, "", params.row);
                      }
                    }
                  },
                  langMap.ignore[this.lang]
                )
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    class: "sci-fi-btn dispose-btn",
                    on: {
                      click: () => {
                        this.sentimentOperate(6, "", params.row);
                      }
                    }
                  },
                  langMap.dispose[this.lang]
                )
              );
            }else if (params.row.operateType == 6) {
              // 添加语音喊话按钮
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    class: "sci-fi-btn intercom-btn",
                    on: {
                      click: () => {
                        this.openIntercomModal(params.row);
                      }
                    }
                  },
                  langMap.voiceIntercomTitle[this.lang]
                )
              );
              // 添加音频播放按钮
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    class: "sci-fi-btn audio-play-btn",
                    on: {
                      click: () => {
                        this.openAudioPlayerModal(params.row);
                      }
                    }
                  },
                  langMap.audioPlaybackTitle[this.lang]
                )
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    class: "sci-fi-btn track-attack-btn",
                    on: {
                      click: () => {
                        this.openBehaviorProhibitionModal(params.row);
                      }
                    }
                  },
                  langMap.trackAttack[this.lang]
                )
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      size: "small"
                    },
                    class: "sci-fi-btn stop-prohibition-btn",
                    on: {
                      click: () => {
                        this.sentimentOperate(8, "", params.row);
                      }
                    }
                  },
                  langMap.stopBehaviorProhibition[this.lang]
                )
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small"
                    },
                    class: "sci-fi-btn disposal-complete-btn",
                    on: {
                      click: () => {
                        this.sentimentOperate(5, "", params.row);
                      }
                    }
                  },
                  langMap.disposalComplete[this.lang]
                )
              );
            }
            return h("div", {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "5px",
                justifyContent: "center"
              }
            }, renderArray);
          }
        }
      ]
    }
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        // 根据路由参数决定是否进入回溯查询模式
        this.isHistoryMode = !!newQuery.timestamp;

        if (newQuery.robotId) {
          this.robotId = parseInt(newQuery.robotId);
        }

        // 在回溯模式下，路由变化时直接根据 timestamp 查询
        if (this.isHistoryMode && this.robotId) {
          this.index = 1;
          this.getDataList();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    // 根据路由参数初始化回溯查询模式和机器人
    this.isHistoryMode = !!this.$route.query.timestamp;

    if (this.$route.query.robotId) {
      this.robotId = parseInt(this.$route.query.robotId);
    }

    this.getList();
    // 获取时进行压缩
    this.recorder = new Recorder({
      sampleBits: 8,
      sampleRate: 8000,
      numChannels: 1
    });

    this.test();
  },
  methods: {
    // 动态计算操作列宽度
    getOperationColumnWidth() {
      // 如果数据为空，返回默认最小宽度
      if (!this.dataList || this.dataList.length === 0) {
        return 100;
      }
      
      // 检查当前数据列表中的按钮数量
      let maxButtons = 0;
      
      this.dataList.forEach(row => {
        let buttonCount = 0;
        if (row.operateType === null) {
          // 未操作状态：2个按钮
          buttonCount = 2;
        } else if (row.operateType == 6) {
          // 处置中状态：5个按钮
          buttonCount = 5;
        }
        
        if (buttonCount > maxButtons) {
          maxButtons = buttonCount;
        }
      });
      
      // 如果没有按钮，返回默认最小宽度
      if (maxButtons === 0) {
        return 100;
      }
      
      const gap = 5; // 按钮间隙
      const padding = 10; // 列内边距
      let calculatedWidth = 0;
      
      // 根据当前语言和按钮数量计算宽度
      if (this.lang === 'zh') {
        // 中文按钮宽度
        // "忽略" - 约 50px
        // "处置" - 约 50px
        // "语音喊话" - 约 70px
        // "音频播放" - 约 70px
        // "行为拒止" - 约 70px
        // "停止行为拒止" - 约 95px
        // "处置完成" - 约 70px
        
        if (maxButtons === 2) {
          // 忽略 (100px) + 处置 (100px)
          calculatedWidth = 100 + 100 ;
        } else if (maxButtons === 5) {
          // 5个按钮
          // 语音喊话 (70px) + 音频播放 (70px) + 行为拒止 (70px)
          // 停止行为拒止 (95px) + 处置完成 (70px)
          calculatedWidth = 70 + 70 + 70 + 95 + 70 + gap * 2;;
        }
      } else {
        // 英文按钮宽度
        // "Ignore" - 约 70px
        // "Dispose" - 约 80px
        // "Voice announcement" - 约 160px
        // "Audio playback" - 约 130px
        // "Behavior prohibition" - 约 175px
        // "Stop behavior prohibition" - 约 215px
        // "Disposal complete" - 约 150px
        
        if (maxButtons === 2) {
          // Ignore (70px) + Dispose (80px)
          calculatedWidth = 100 + 100 + gap + padding;
        } else if (maxButtons === 5) {
          // 5个按钮，分两行
          // 第一行：Voice announcement (160px) + Audio playback (130px) + Behavior prohibition (175px)
          // 第二行：Stop behavior prohibition (215px) + Disposal complete (150px)
          const row1Width = 160 + 130 + 175 + gap * 2;
          const row2Width = 215 + 150 + gap;
          calculatedWidth = Math.max(row1Width, row2Width) + padding;
        }
      }
      
      return Math.max(calculatedWidth, 50);
    },
    sentimentOperate(type, item, data) {
      let msg = "";
      switch (type) {
        case 1:
          msg = langMap.confirmPlayWarning[this.lang];
          break;
        case 2:
          msg = langMap.confirmTalkInspection[this.lang];
          break;
        case 3:
          msg = langMap.confirmTrackTarget[this.lang];
          break;
        case 4:
          msg = langMap.confirmIgnoreAlarm[this.lang];
          break;
        case 5:
          msg = langMap.confirmSendComplete[this.lang];
          break;
        case 6:
          msg = langMap.confirmSendDispose[this.lang];
          break;
        case 8:
          msg = langMap.confirmStopBehaviorProhibition[this.lang];
          break;
      }
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: msg,
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.timestamp,
            ret: type,
            item: item
          };
          api
            .postData(
              "notice-server/cmd/sentiment",
              { code: data.code, data: d },
              this
            )
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
                this.getDataList();
              }
              this.$Spin.hide();
            });
        }
      });
    },

    cancelDetail() {
      this.detailedDisplay = false;
    },

    issuedDetail() {
      this.issuedDisplay = false;
    },

    // 打开行为拒止弹窗
    openBehaviorProhibitionModal(row) {
      this.currentBehaviorProhibitionRow = row;
      let data = JSON.parse(row.data);
      this.behaviorProhibitionData = {
        msg: data.msg,
        img: data.img,
        x:data.x,
        y:data.y,
        z:data.z,
        targetList: data.targetList || [] 
      };
      this.behaviorProhibitionModalVisible = true;
    },

    // 行为拒止成功回调
    onBehaviorProhibitionSuccess(res) {
      this.getDataList();
    },

    // 行为拒止错误回调
    onBehaviorProhibitionError(error) {
      // 错误已在组件内部处理，这里可以做附加处理
    },

    // 行为拒止取消回调
    onBehaviorProhibitionCancel() {
      this.currentBehaviorProhibitionRow = null;
      this.behaviorProhibitionData = {};
    },

    // 打开音频播放弹窗
    openAudioPlayerModal(row) {
      // 查找机器人信息
      const robot = this.robotList.find(r => r.code === row.code);
      if (!robot) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.robotNotFound ? langMap.robotNotFound[this.lang] : '未找到机器人信息'
        });
        return;
      }
      
      // 设置机器人信息
      this.audioPlayerRobotInfo = {
        id: robot.id,
        name: robot.name,
        serialNumber: row.code,
        avatar: robot.avatar || require('@/assets/images/voice/Robot-icon.png')
      };
      this.audioPlayerModalVisible = true;
    },

    // 关闭音频播放弹窗
    closeAudioPlayerModal() {
      this.audioPlayerModalVisible = false;
      this.audioPlayerRobotInfo = {};
    },

    // 打开语音对讲弹窗
    openIntercomModal(row) {
      // 查找机器人信息
      const robot = this.robotList.find(r => r.code === row.code);
      if (!robot) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.robotNotFound ? langMap.robotNotFound[this.lang] : '未找到机器人信息'
        });
        return;
      }
      
      // 设置机器人信息
      this.intercomRobotInfo = {
        id: robot.id,
        name: robot.name,
        serialNumber: row.code,
        avatar: robot.avatar || require('@/assets/images/voice/Robot-icon.png')
      };
      this.intercomModalVisible = true;
    },

    // 关闭语音对讲弹窗
    closeIntercomModal() {
      this.intercomModalVisible = false;
      this.intercomRobotInfo = {};
    },

    //获取机器人列表
    getList() {
      this.tableLoading = true;
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data;
          if (this.robotList.length > 0) {
            // 如果外部（路由）已经指定了 robotId，就优先用外部的
            if (!this.robotId) {
              this.robotId = this.robotList[0].id;
            } else {
              // 确认当前 robotId 是否在列表中，否则回退到第一个
              const exists = this.robotList.some(r => String(r.id) === String(this.robotId));
              if (!exists) {
                this.robotId = this.robotList[0].id;
              }
            }
            this.getDataList();
          }
        }
        this.tableLoading = false;
      });
    },

    // 查询 / 恢复查询 按钮点击
    onSearchOrRecoverClick() {
      if (this.isHistoryMode) {
        // 从回溯模式恢复为普通查询模式
        const query = { ...this.$route.query };
        delete query.timestamp;
        this.isHistoryMode = false;
        this.times = [];
        this.index = 1;
        this.$router.push({ path: this.$route.path, query });
      } else {
        this.searchData();
      }
    },

    //搜索数据
    searchData() {
      this.index = 1;
      this.getDataList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getDataList();
    },

    getDataList() {
      if (!this.robotId) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseSelectRobot[this.lang]
        });
        return;
      }
      this.dataList = [];
      this.dataTotal = 0;

      let url =
        "notice-server/data/sentiment/list?robotId=" +
        this.robotId;

      const timestamp = this.$route.query.timestamp;

      if (timestamp) {
        // 回溯模式下，直接使用 timestamp 入参查询
        url += "&timestamp=" + timestamp;
      } else {
        let start = "";
        let end = "";
        if (this.times.length == 2) {
          if (this.times[0]) {
            start = timeUtil.formatTime(this.times[0]);
          }
          if (this.times[1]) {
            end = timeUtil.formatTime(this.times[1]);
          }
        }
        url += "&start=" + start + "&end=" + end;
      }

      url += "&index=" + this.index;

      this.tableLoading2 = true;
      api
        .getData(
          url,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.dataList = res.data.rows;
            this.dataTotal = res.data.total;
          }
          this.tableLoading2 = false;
        });
    },

    // 开始录音
    handleStart() {
      let _this = this;
      this.recorder = new Recorder();
      Recorder.getPermission().then(
        () => {
          console.log(langMap.startRecording[this.lang]);
          this.recorder.start(); // 开始录音
        },
        error => {
          _this.$Notice.info({
            title: langMap.tip[this.lang],
            desc: langMap.allowMicrophone[this.lang]
          });
          console.log(`${error.name} : ${error.message}`);
        }
      );
    },

    handleStop() {
      this.recorder.stop(); // 停止录音
    },
    handlePlay() {
      // 播放录音
      if (this.recorder == null || this.recorder.duration === 0) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseRecordFirst[this.lang]
        });
        return;
      }
      this.recorder.play();
      // 播放时长
      this.timer = setInterval(() => {
        try {
          this.playTime = this.recorder.getPlayTime();
        } catch (error) {
          this.timer = null;
        }
      }, 100);

      if (this.recorder && this.playTime > this.recorder.duration) {
        this.handleStopPlay();
      }
    },

    handleStopPlay() {
      this.recorder.stopPlay(); // 停止播放
      // 播放时长
      this.playTime = this.recorder.getPlayTime();
      this.timer = null;
    },
    handleDestroy() {
      this.recorder.destroy(); // 重置
      this.timer = null;
    },

    broadcastOrStop() {
      // 开始播放
      if (this.flag) {
        this.icon = "ios-pause-outline";
        this.flag = false;
        this.handlePlay(); //播放
      } else {
        this.icon = "ios-play-outline";
        this.flag = true;
        this.handleStopPlay(); //停止
      }
    },

    blobToBase64(blob) {
      const fs = new FileReader();
      return new Promise((resolve, reject) => {
        fs.onload = e => {
          resolve(e.target.result);
        };
        fs.onerror = reject;
        fs.readAsDataURL(blob);
      });
    },
    // 上传录音
    async uploadRecord(data) {
      if (this.recorder == null || this.recorder.duration === 0) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseRecordFirst[this.lang]
        });
        return;
      }
      this.recorder.pause(); // 暂停录音
      this.timer = null;

      let robotId = data.robotId;
      let timestamp = data.timestamp;
      let type = "wav";

      let formData = new FormData();
      let file = this.recorder.getWAVBlob(); // 获取wav格式音频数据
      let newFile = new Blob([file], { type: "audio/wav" });
      let fileOfBlob = new File([newFile], new Date().getTime() + ".wav");
      formData.append("file", fileOfBlob);
      let info = {
        base64: await this.blobToBase64(fileOfBlob), // 录音文件转成 base64
        type: type,
        suffixName: "wav",
        data: {
          robotId: robotId,
          timestamp: timestamp
        }
      };
      api.postData("notice-server/file/upload/voice", info, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.$Notice.success({
            title: langMap.success[this.lang],
            desc: res.message
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.detail-item {
  display: flex;
  border: 1px solid #e8eaec;
  margin-bottom: -1px;
  line-height: 30px;
  padding-bottom: 2px;
  padding-left: 8px;
}

/deep/ .ivu-modal-wrap .ivu-modal{
    top:10px
}

/* 科幻风格详情项 */
.sci-fi-detail-item {
  margin-bottom: 20px;
  padding: 15px;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, rgba(10, 22, 40, 0.8) 100%);
  border-left: 3px solid #00d4ff;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 212, 255, 0.15);
  transition: all 0.3s ease;
}

.sci-fi-detail-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, 
    transparent 25%, 
    rgba(0, 212, 255, 0.03) 25%, 
    rgba(0, 212, 255, 0.03) 50%, 
    transparent 50%, 
    transparent 75%, 
    rgba(0, 212, 255, 0.03) 75%);
  background-size: 10px 10px;
  pointer-events: none;
  opacity: 0.5;
}

.sci-fi-detail-item:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 20px rgba(0, 212, 255, 0.3);
  border-left-color: #00ffff;
}

.detail-label {
  font-weight: 600;
  color: #00d4ff;
  margin-bottom: 8px;
  font-size: 14px;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
}

.detail-label::after {
  content: '';
  display: block;
  width: 40px;
  height: 2px;
  background: linear-gradient(to right, #00d4ff, transparent);
  margin-top: 5px;
}

.detail-value {
  color: #e8f4f8;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-all;
  position: relative;
  z-index: 1;
}

.image-container {
  padding: 20px;
}

.detail-image-wrapper {
  margin-top: 10px;
  border: 2px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  background: #000;
}

.detail-image-wrapper::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, #00d4ff, #0099cc, #00d4ff);
  background-size: 200% 200%;
  animation: border-glow 3s ease infinite;
  z-index: -1;
  border-radius: 8px;
}

@keyframes border-glow {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.detail-image {
  width: 100%;
  display: block;
  transition: transform 0.3s ease;
}

.detail-image:hover {
  transform: scale(1.02);
}
</style>

<style lang="less">
.articlemanagement {
  /* 科幻按钮基础样式 */
  .sci-fi-btn {
    position: relative;
    overflow: hidden;
    border: none !important;
    border-radius: 6px !important;
    font-weight: 500;
    letter-spacing: 1px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    min-width: 29px;
    min-height: 29px;
  }

  .sci-fi-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
    z-index: 1;
  }

  .sci-fi-btn:hover::before {
    left: 100%;
  }

  .sci-fi-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }

  .sci-fi-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }

  /* 忽略按钮 - 红色 */
  .ignore-btn:not([disabled]) {
    background: linear-gradient(135deg, #ff4757, #ff3742) !important;
    border-color: #ff4757 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(255, 71, 87, 0.4);
  }

  .ignore-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #ff3742, #ff4757) !important;
    box-shadow: 0 8px 25px rgba(255, 71, 87, 0.6);
  }

  /* 处置按钮 - 橙色 */
  .dispose-btn:not([disabled]) {
    background: linear-gradient(135deg, #ff9900, #ff8800) !important;
    border-color: #ff9900 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(255, 153, 0, 0.4);
  }

  .dispose-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #ff8800, #ff9900) !important;
    box-shadow: 0 8px 25px rgba(255, 153, 0, 0.6);
  }

  /* 追踪攻击按钮 - 深橙色 */
  .track-attack-btn:not([disabled]) {
    background: linear-gradient(135deg, #ff9900, #ff7700) !important;
    border-color: #ff9900 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(255, 153, 0, 0.4);
    position: relative;
  }

  .track-attack-btn:not([disabled])::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
  }

  .track-attack-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #ff7700, #ff9900) !important;
    box-shadow: 0 8px 25px rgba(255, 153, 0, 0.6);
  }

  .track-attack-btn:not([disabled]):hover::after {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  /* 语音喊话按钮 - 青蓝色 */
  .intercom-btn:not([disabled]) {
    background: linear-gradient(135deg, #00bfff, #0099cc) !important;
    border-color: #00bfff !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(0, 191, 255, 0.4);
    position: relative;
  }

  .intercom-btn:not([disabled])::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
  }

  .intercom-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #0099cc, #00bfff) !important;
    box-shadow: 0 8px 25px rgba(0, 191, 255, 0.6);
  }

  .intercom-btn:not([disabled]):hover::after {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  /* 音频播放按钮 - 蓝紫色 */
  .audio-play-btn:not([disabled]) {
    background: linear-gradient(135deg, #5e72e4, #825ee4) !important;
    border-color: #5e72e4 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(94, 114, 228, 0.4);
    position: relative;
  }

  .audio-play-btn:not([disabled])::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
  }

  .audio-play-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #825ee4, #5e72e4) !important;
    box-shadow: 0 8px 25px rgba(94, 114, 228, 0.6);
  }

  .audio-play-btn:not([disabled]):hover::after {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  /* 停止行为拒止按钮 - 灰色 */
  .stop-prohibition-btn:not([disabled]) {
    background: linear-gradient(135deg, #666666, #555555) !important;
    border-color: #666666 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(102, 102, 102, 0.4);
  }

  .stop-prohibition-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #555555, #666666) !important;
    box-shadow: 0 8px 25px rgba(102, 102, 102, 0.6);
  }

  /* 处置完成按钮 - 绿色 */
  .disposal-complete-btn:not([disabled]) {
    background: linear-gradient(135deg, #00ff88, #00cc6a) !important;
    border-color: #00ff88 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(0, 255, 136, 0.4);
  }

  .disposal-complete-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #00cc6a, #00ff88) !important;
    box-shadow: 0 8px 25px rgba(0, 255, 136, 0.6);
  }

  /* disabled状态的按钮样式 */
  .sci-fi-btn[disabled] {
    background: linear-gradient(135deg, #c5c8ce, #a8abb2) !important;
    border-color: #c5c8ce !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(197, 200, 206, 0.2) !important;
    cursor: not-allowed !important;
  }

  .sci-fi-btn[disabled]::before {
    display: none !important;
  }

  .sci-fi-btn[disabled]:hover {
    transform: none !important;
    box-shadow: 0 2px 8px rgba(197, 200, 206, 0.2) !important;
  }

  /* 表格单元格适配 */
  .ivu-table-cell {
    padding-left: 2px;
    padding-right: 2px;
    overflow: visible;
  }

  /* 详情链接按钮 - 青色 */
  .detail-link-btn:not([disabled]) {
    background: linear-gradient(135deg, #00d4ff, #0099cc) !important;
    border-color: #00d4ff !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(0, 212, 255, 0.4);
  }

  .detail-link-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #0099cc, #00d4ff) !important;
    box-shadow: 0 8px 25px rgba(0, 212, 255, 0.6);
  }

  /* 记录链接按钮 - 紫色 */
  .record-link-btn:not([disabled]) {
    background: linear-gradient(135deg, #9b59b6, #8e44ad) !important;
    border-color: #9b59b6 !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(155, 89, 182, 0.4);
  }

  .record-link-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #8e44ad, #9b59b6) !important;
    box-shadow: 0 8px 25px rgba(155, 89, 182, 0.6);
  }

  /* 弹窗关闭按钮 - 灰蓝色 */
  .modal-close-btn:not([disabled]) {
    background: linear-gradient(135deg, #5a6c7d, #486581) !important;
    border-color: #5a6c7d !important;
    color: white !important;
    box-shadow: 0 4px 15px rgba(90, 108, 125, 0.4);
  }

  .modal-close-btn:not([disabled]):hover {
    background: linear-gradient(135deg, #486581, #5a6c7d) !important;
    box-shadow: 0 8px 25px rgba(90, 108, 125, 0.6);
  }
}

/* 详情弹窗特殊样式 */
.detail-modal {
  .ivu-modal-body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /* 美化滚动条 */
  .ivu-modal-body::-webkit-scrollbar {
    width: 8px;
  }

  .ivu-modal-body::-webkit-scrollbar-track {
    background: rgba(10, 22, 40, 0.5);
    border-radius: 4px;
  }

  .ivu-modal-body::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #00d4ff, #0099cc);
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  }

  .ivu-modal-body::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #00ffff, #00d4ff);
  }
}
</style>
